import React from 'react';
import { Container, Row, Col, Card, Alert } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import '../ServicePage.css';

function ServerAdministration() {
    const linuxServices = [
        "Installazione e configurazione Ubuntu/CentOS/Debian",
        "Gestione servizi Apache/Nginx/PHP/MySQL",
        "Configurazione firewall e sicurezza",
        "Monitoraggio sistema e performance",
        "Backup automatici",
        "Aggiornamenti di sicurezza",
        "Ottimizzazione prestazioni",
        "Troubleshooting e risoluzione problemi"
    ];

    const windowsServices = [
        "Installazione e configurazione Windows Server",
        "Active Directory e gestione domini",
        "Exchange Server e posta elettronica",
        "IIS e applicazioni web",
        "SQL Server e database",
        "Backup e disaster recovery",
        "Politiche di sicurezza",
        "Remote Desktop Services"
    ];

    const monitoringFeatures = [
        "Monitoraggio 24/7 dello stato server",
        "Allerte automatiche via email/SMS",
        "Report mensili dettagliati",
        "Dashboard in tempo reale",
        "Controllo risorse (CPU, RAM, Disk)",
        "Monitoraggio servizi critici",
        "Log analysis e debugging",
        "Prevenzione problemi proattiva"
    ];

    return (
        <div className="service-page">
            {/* Hero Section */}
            <section className="service-hero-detail">
                <Container>
                    <Row className="align-items-center min-vh-50">
                        <Col lg={8} className="mx-auto text-center">
                            <div className="service-hero-icon">🖥️</div>
                            <h1 className="service-hero-title gradient-text">
                                Amministrazione Server
                            </h1>
                            <p className="service-hero-description">
                                Gestione professionale di server Linux e Windows, monitoraggio continuo,
                                backup automatici e supporto tecnico specializzato.
                            </p>
                            <div className="service-hero-meta">
                                {/* <div className="price-highlight">A partire da €150/mese</div> */}
                                <div className="specialty-badge">Linux & Windows</div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Content */}
            <section className="service-content section-padding">
                <Container>
                    <Row>
                        <Col lg={8}>
                            <div className="service-description">
                                <h3>Amministrazione Server Professionale</h3>
                                <p>
                                    Gestisco server Linux e Windows con competenza e professionalità,
                                    garantendo massime prestazioni, sicurezza e disponibilità per i tuoi servizi critici.
                                </p>
                                <p>
                                    Con anni di esperienza nella gestione di infrastrutture IT,
                                    offro un servizio completo che include installazione, configurazione,
                                    monitoraggio e manutenzione continua.
                                </p>
                            </div>

                            <div className="server-types">
                                <Row>
                                    <Col lg={6} className="mb-4">
                                        <Card className="server-type-card">
                                            <Card.Body>
                                                <h4><i className="fab fa-linux"></i> Server Linux</h4>
                                                <ul className="server-services-list">
                                                    {linuxServices.map((service, index) => (
                                                        <li key={index}>{service}</li>
                                                    ))}
                                                </ul>
                                            </Card.Body>
                                        </Card>
                                    </Col>

                                    <Col lg={6} className="mb-4">
                                        <Card className="server-type-card">
                                            <Card.Body>
                                                <h4><i className="fab fa-windows"></i> Windows Server</h4>
                                                <ul className="server-services-list">
                                                    {windowsServices.map((service, index) => (
                                                        <li key={index}>{service}</li>
                                                    ))}
                                                </ul>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </div>

                            <Alert variant="success" className="monitoring-alert">
                                <h5><i className="fas fa-chart-line"></i> Monitoraggio Proattivo</h5>
                                <p>
                                    Monitoriamo i tuoi server 24/7 per prevenire problemi prima che si verifichino,
                                    garantendo la massima disponibilità dei tuoi servizi.
                                </p>
                            </Alert>

                            <div className="monitoring-section">
                                <h3>Sistema di Monitoraggio</h3>
                                <Row>
                                    {monitoringFeatures.map((feature, index) => (
                                        <Col md={6} key={index} className="mb-2">
                                            <div className="feature-item">
                                                <span className="feature-check">✓</span>
                                                {feature}
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </div>

                            <div className="service-process">
                                <h3>Come Lavoriamo</h3>
                                <div className="process-steps">
                                    <div className="process-step-item">
                                        <div className="step-number">1</div>
                                        <div className="step-text">Analisi iniziale dell'infrastruttura esistente</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">2</div>
                                        <div className="step-text">Configurazione e ottimizzazione server</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">3</div>
                                        <div className="step-text">Implementazione sistema di monitoraggio</div>
                                    </div>
                                    <div className="process-step-item">
                                        <div className="step-number">4</div>
                                        <div className="step-text">Manutenzione continua e supporto</div>
                                    </div>
                                </div>
                            </div>
                        </Col>

                        <Col lg={4}>
                            <div className="service-sidebar">
                                <Card className="service-info-card">
                                    <Card.Body>
                                        <h4>Piani di Servizio</h4>
                                        <div className="pricing-plan">
                                            <h5>Piano Base</h5>
                                            {/* <div className="plan-price">€150/mese</div> */}
                                            <ul>
                                                <li>1 Server</li>
                                                <li>Monitoraggio base</li>
                                                <li>Backup settimanali</li>
                                                <li>Supporto 9-18</li>
                                            </ul>
                                        </div>

                                        <div className="pricing-plan">
                                            <h5>Piano Professional</h5>
                                            {/* <div className="plan-price">€300/mese</div> */}
                                            <ul>
                                                <li>Fino a 3 Server</li>
                                                <li>Monitoraggio 24/7</li>
                                                <li>Backup giornalieri</li>
                                                <li>Supporto prioritario</li>
                                            </ul>
                                        </div>
                                    </Card.Body>
                                </Card>

                                <Card className="security-card">
                                    <Card.Body>
                                        <h4>🔒 Sicurezza Garantita</h4>
                                        <ul>
                                            <li>Firewall configurati</li>
                                            <li>Aggiornamenti automatici</li>
                                            <li>Scan antivirus</li>
                                            <li>Backup criptati</li>
                                            <li>Accesso SSH sicuro</li>
                                        </ul>
                                    </Card.Body>
                                </Card>

                                <div className="cta-section">
                                    <a href="#contact" className="btn-gradient w-100 mb-3">
                                        <span>Richiedi Preventivo</span>
                                    </a>
                                    <Link to="/services" className="btn btn-outline-primary w-100">
                                        Torna ai Servizi
                                    </Link>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
}

export default ServerAdministration;